import './lakelife/style';
import FormStructure from './lakelife/form_structure';

export default FormStructure;